import React, { lazy } from 'react';

import LoadScreen from './Loadscreen/Loadscreen';
import Hero from './Hero/Hero';
import WhyReachtix from './whyreachtix/whyreachtix';
import ServiceCard from './ServiceCard/ServiceCard';
import IndustriesSection from './IndustriesSection/IndustriesSection';
import OurApproach from './OurApproach/OurApproach';
import StepSection from './StepSection/StepSection';
import Cta from './CTASection/CTASection';


const Homepage = () => {
    window.scroll(0, 0)
    return (
        <>
            <LoadScreen />
            <div className="landing-page">

                <div>
                    <div >
                        <Hero />
                        <WhyReachtix />
                        <ServiceCard />
                        <IndustriesSection />
                        <OurApproach />
                        <StepSection />
                        <Cta />
                    </div>
                </div>

            </div>
        </>

    );
};

export default Homepage;